<div class="d-flex align-items-center" mat-dialog-title>
    <span
        >Project {{ project?.afas_project_id }} - {{ project?.name }}
        {{ project?.afas_project_id ? 'aanpassen' : 'aanmaken' }}</span
    >
    <span class="flex-fill"></span>
    <button (click)="cancel()" mat-icon-button aria-label="Sluiten">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content>
    @if (fgProject) {
        <div class="px-3" [formGroup]="fgProject">
            <div class="row">
                @if (environment.subProjects) {
                    <div class="col-8">
                        <ng-select
                            class="ng-select-fill project-selection"
                            #projectSelect
                            [formControl]="fgProject.controls.parent_id"
                            [typeahead]="searchAfasProjects$"
                            [clearable]="true"
                            [selectableGroup]="false"
                            [items]="mainProjects"
                            placeholder="Project"
                            groupBy="mainProject"
                            bindLabel="name"
                            bindValue="afas_project_id">
                            <ng-template ng-label-tmp let-item="item">
                                <b>{{ item.afas_project_id }}</b> {{ item.name }}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                <b>{{ item.afas_project_id }}</b> {{ item.name }}
                            </ng-template>
                        </ng-select>
                        <mat-error [control]="fgProject.controls.parent_id"></mat-error>
                    </div>
                }
                <div class="col-8">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Projectnummer</mat-label>
                        <input
                            [formControl]="fgProject.controls.afas_project_id"
                            matInput
                            maxlength="15"
                            placeholder="Project (naam, nummer, locatie)" />
                        <mat-error [control]="fgProject.controls.afas_project_id"></mat-error>
                    </mat-form-field>
                </div>
                <div class="col-8">
                    <ng-select
                        class="ng-select-fill w-100"
                        [formControl]="fgProject.controls.group"
                        [clearable]="true"
                        [items]="groups"
                        placeholder="Groep"
                        bindLabel="label"
                        bindValue="value">
                    </ng-select>
                    <mat-error [control]="fgProject.controls.projectmanager_id"></mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-24">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Project beschrijving</mat-label>
                        <input [formControl]="fgProject.controls.name" matInput placeholder="Project beschrijving" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-24">
                    <ng-select
                        class="ng-select-fill w-100"
                        [placeholder]="environment.executorName | ucFirst"
                        [formControl]="fgProject.controls.performer_id"
                        [clearable]="true"
                        [items]="executors"
                        bindLabel="name"
                        bindValue="id">
                    </ng-select>
                    <mat-error [control]="fgProject.controls.performer_id"></mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-24">
                    <ng-select
                        class="ng-select-fill w-100"
                        [formControl]="fgProject.controls.asphalt_performer_id"
                        [clearable]="true"
                        [items]="asphaltExecutors"
                        placeholder="Asfaltuitvoerder"
                        bindLabel="name"
                        bindValue="id">
                    </ng-select>
                    <mat-error [control]="fgProject.controls.asphalt_performer_id"></mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-24">
                    <ng-select
                        class="ng-select-fill w-100"
                        [formControl]="fgProject.controls.projectmanager_id"
                        [clearable]="true"
                        [items]="projectManagers"
                        placeholder="Projectleider"
                        bindLabel="name"
                        bindValue="id">
                    </ng-select>
                    <mat-error [control]="fgProject.controls.projectmanager_id"></mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-24">
                    <app-location-select
                        [control]="fgProject.controls.location"
                        selectClass="w-100"
                        source="ProjectEditDialogComponent.location"
                        resultFilter="localityOrTown">
                    </app-location-select>
                    <mat-error [control]="fgProject.controls.location"></mat-error>
                </div>
            </div>
        </div>
    }
    @if (project?.status | projectStatus) {
        <div class="status-closed">
            Dit project heeft de status {{ project.status_name }} en kan daarom niet meer worden gebruikt. Deze status
            is aan te passen in Afas.
        </div>
    }

    @if (!fgProject) {
        <div class="text-center p-4">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="mt-2">Project laden...</p>
        </div>
    }

    <app-planning-table [title]="project?.afas_project_id" [projectId]="project?.afas_project_id"></app-planning-table>
</div>

<div class="justify-content-between" mat-dialog-actions>
    <button [disabled]="saving" (click)="cancel()" mat-button>Annuleren</button>

    <button [disabled]="saving || !fgProject || fgProject?.disabled" (click)="save()" mat-raised-button color="primary">
        @if (!saving) {
            <span>Opslaan</span>
        } @else if (saving) {
            <span class="d-flex align-items-center">
                <mat-spinner class="me-2" diameter="20"></mat-spinner>
                Opslaan...
            </span>
        }
    </button>
</div>
